let inject = [
    '$scope',
    'reportPaymentHistoryService',
    '$state',
    '$rootScope',
    'SharedService',
    '$timeout',
    'ngAuthSettings',
    'CartService',
    'SessionService',
    'NgTableParams',
    '$uibModal',
    '$filter'
];

class ReportPaymentHistoryController {
    constructor($scope,
                reportPaymentHistoryService,
                $state,
                $rootScope,
                SharedService,
                $timeout,
                ngAuthSettings,
                CartService,
                SessionService,
                NgTableParams,
                $uibModal,
                $filter) {
        this.$state = $state;
        this.SessionService = SessionService;
        this.ngAuthSettings = ngAuthSettings;
        this.CartService = CartService;
        this.$filter = $filter;
        // this.$scope = $scope;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.NgTableParams = NgTableParams;
        this.reportPaymentsService = reportPaymentHistoryService;
        this.$uibModal = $uibModal;
        this.SharedService = SharedService;

        this.payments = null;
        this.dataAdd = null;
        this.state = {};
        this.branches = [];

        this.statePayment = {};
        this.paymentSelected = null;
        this.paymentSelectedBase = null;
        this.paymentVrNetoTotal = 0;
        this.paymentVrNetoPendiente = 0;
        this.watchingPayment = false;

        this.showDateFilter = false;
        this.showErrorFilter = false;
        this.showErrorFilterDate = false;
        this.errorMessageFilter = '';

        // ngTable Params
        this.ngTableConfigPayment = null;
        this.ngTableColsPayment = null;

        this.totalValueToPayPayments = 0;
        this.totalValuePendingPayments = 0;
        this.updatedAt = '';

        // ngTable Params
        this.ngTableConfig = null;
        this.ngTableCols = null;
        this.thirdSelected = null;
        this.branchesSelected = null;

        this.exportingData = false;
        this.exportingDataPdf = false;
        this.exportCorrectExcel = false;
        this.exportCorrectPdf = false;
        this.exportingDataDetail = false;
        this.exportingDataDetailPdf = false;


        this.sort = null;
        this.searchText = '';
        this.sortType = 'pedido_id';
        this.sortOrientation = 'DESC';
        this.sortReverse = true;
        this.userPayments = [];
        this.summary = [];
        this.itemsPerPage = 12;
        this.loadingUserPayments = true;
        this.loadedUserPayments = false;
        this.errorloadingUserPayments = false;
        this.currentPage = 1;
        this.actualPage = 0;
        this.filters = {};
        this.filtersCopy = {};


        this.maxSize = 5;
        this.bigTotalItems = 0;
        this.bigCurrentPage = 1;
        this.totalItemsPage = 12;
        this.statictics = {};

        this.bigTotalItemsDetails = 0;
        this.bigCurrentPageDetail = 1;
        this.totalItemsPageDetail = 12;

        this.rangoDiasConsultaHistoricoPagos = 0;


        this.count = 0;

        this.fechaDesde = null;
        this.fechaHasta = null; 

    }

    $onInit() {
        if (!this.shCtrl.globals.currentClient) this.shCtrl.globals.currentClient = {};
        if (!this.shCtrl.globals.currentClient.third) return;
        if (!this.shCtrl.globals.currentClient.third.documentNumber) return;
        let paginar = __env.adaptative === true;
        this.getPaymentStates(false, paginar);

    }

    getBranches(item) {
        this.reportPaymentsService.getBranchesByThirdId(item.id).then(response => {
            this.branches = response;
        }); 
    }

    getPaymentStates(manual, paginar = true, paymentRequest = false, paymentObject = null, paginationInicial, paginationFinal) {

        this.sort = manual;

        let documentNumber = '';
        documentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
        
        let limit = this.totalItemsPage;
        let page = this.bigCurrentPage;

        this.rangoDiasConsultaHistoricoPagos = this.shCtrl.ngAuthSettings.site.info.company.rangoDiasConsultaHistoricoPagos;

        if (!paginar) {
            limit = "";
            page = "";
        }else{
            if (paginationInicial==undefined && paginationFinal==undefined) {
                paginationInicial   =   0;
                paginationFinal     =   limit;
            }
        }

        if (this.fecha_ini != undefined && this.fecha_ini !=undefined) {
            manual = true;
        }

        this.showErrorFilter = false;
        this.showErrorFilterDate = false;
        this.showDateFilter = false;
        this.state = {};
        this.state.loading = true;
        if (manual) {
            
            this.fecha_ini = this.getFormattedDate(this.fecha_ini);
            this.fecha_fin = this.getFormattedDate(this.fecha_fin);            
            
            let dateFilter = (this.fecha_ini && this.fecha_fin)? 1 : 0;
            

            if((this.fecha_ini && this.fecha_fin) || (!this.fecha_ini && !this.fecha_fin)){
                if (this.fecha_ini < this.fecha_fin) {
                    this.payments = [];
                    this.dataAdd=[];
                    this.showDateFilter = dateFilter;
                    this.reportPaymentsService.getPaymentStates(documentNumber, 30, dateFilter,this.fecha_ini, this.fecha_fin).then(response => {
                        this.state.loading = false;
                        this.state.loaded = true;

                        if(!response.error){
                            this.dataAdd = response.data.adicional;
                            this.bigTotalItems = response.data.pagos.length;
                            let temp_payments = response.data.pagos.slice(paginationInicial,paginationFinal);;
                            temp_payments.forEach(element => {
                                let dateArr = element.Fecha_Recaudo.split("/");
                                this.payments.push({
                                    Fecha_Recaudo: new Date(dateArr[2],dateArr[1],dateArr[0]) ,
                                    Id_Cliente: element.Id_Cliente,
                                    Medio_pago: element.Medio_pago,
                                    Notas: element.Notas,
                                    Nro_docto: parseFloat(element.Nro_docto),
                                    Referencia: element.Referencia,
                                    Rowid_Docto: element.Rowid_Docto,
                                    Valor_recaudo: parseFloat(element.Valor_recaudo),
                                    cia: element.cia,
                                    cliente: element.cliente,
                                    estado_documento: element.estado_documento,
                                    f350_id_clase_docto: element.f350_id_clase_docto,
                                    f354_fecha_recaudo: element.f354_fecha_recaudo,
                                    f_nit_compania: element.f_nit_compania,
                                    f_nombre_compania: element.f_nombre_compania,
                                    id_tipo_docto: element.id_tipo_docto,
                                    sucursal_id: element.sucursal_id,
                                });
                            });

                            this.initNgTable();
                        }else{
                            this.state.loading = false;
                            this.state.error = true;
                            this.state.loaded = true;
                        }
                        this.updatedAt = this.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                        this.fechaDesde = ""+ this.fecha_ini;
                        this.fechaHasta = ""+ this.fecha_fin;
                    }).catch(error => {
                        this.state.loading = false;
                        this.state.error = true;
                        this.state.loaded = true;
                    });
                }else
                {
                    this.state.loading = false;
                    this.showErrorFilter = false;
                    this.showErrorFilterDate = true;
                    this.state.loaded = false;
                }
            }else{
                this.state.loading = false;
                this.showErrorFilter = true;
                this.showErrorFilterDate = false;
                this.payments=[];
                this.state.loaded = true;
            }            
        } else {

            this.payments = [];
            this.dataAdd=[];
            this.reportPaymentsService.getPaymentStates(documentNumber)
                .then(response => {
                    this.state.loading = false;
                    this.state.loaded = true;

                    if(!response.error){
                        this.dataAdd = response.data.adicional;
                        this.bigTotalItems = response.data.pagos.length;
                        let temp_payments = response.data.pagos.slice(paginationInicial,paginationFinal);
                        temp_payments.forEach(element => {
                            let dateArr = element.Fecha_Recaudo.split("/");
                            this.payments.push({
                                Fecha_Recaudo: new Date(dateArr[2],dateArr[1],dateArr[0]) ,
                                Id_Cliente: element.Id_Cliente,
                                Medio_pago: element.Medio_pago,
                                Notas: element.Notas,
                                Nro_docto: parseFloat(element.Nro_docto),
                                Referencia: element.Referencia,
                                Rowid_Docto: element.Rowid_Docto,
                                Valor_recaudo: parseFloat(element.Valor_recaudo),
                                cia: element.cia,
                                cliente: element.cliente,
                                estado_documento: element.estado_documento,
                                f350_id_clase_docto: element.f350_id_clase_docto,
                                f354_fecha_recaudo: element.f354_fecha_recaudo,
                                f_nit_compania: element.f_nit_compania,
                                f_nombre_compania: element.f_nombre_compania,
                                id_tipo_docto: element.id_tipo_docto,
                                sucursal_id: element.sucursal_id,
                            });
                        });

                        this.initNgTable();
                    }else{
                        this.state.error = true;
                        this.state.loaded = true;
                        
                    }
                    this.updatedAt = this.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                })
                .catch((error) => {
                    console.log(error);
                    this.state.loading = false;
                    this.state.error = true;
                    this.state.loaded = true;
                });
        }
        
    }

    selectPayment(paymentSelected, paginar = false) {
        this.watchingPayment = true;
        this.statePayment.loading = true;
        this.statePayment.loaded = false;
        this.exportCorrectExcel = false;
        this.exportCorrectPdf = false;

        this.paymentSelectedBase = paymentSelected;
        this.paymentSelected=[];
        
        let documentNumber = '';
        documentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
        let typeDocument = this.paymentSelectedBase.id_tipo_docto;
        let numberDocument = this.paymentSelectedBase.Nro_docto;

        this.reportPaymentsService.getPaymentState(documentNumber,numberDocument,typeDocument)
            .then((response) => {
                this.statePayment.loading = false;
                this.statePayment.loaded = true;
                let temp_detalles = response.data.detalles;

                temp_detalles.forEach(element => {
                    let signo = (element.valor_negativo_positivo=='-')?-1:1;

                    this.paymentSelected.push({
                        Nro_docto_cruce: parseFloat(element.Nro_docto_cruce),
                        Pronto_pago_aplicado: parseFloat(element.Pronto_pago_aplicado) ,
                        Rowid_Docto: element.Rowid_Docto,
                        Rowid_Movto: element.Rowid_Movto,
                        Saldo_Docto: parseFloat(element.Saldo_Docto),
                        Tipo_Docto_cruce: element.Tipo_Docto_cruce,
                        Valor_aplicado: parseFloat(element.Valor_aplicado) * signo,
                        cia: element.cia,
                        valor_negativo_positivo: element.valor_negativo_positivo,
                    });
                });
                
                this.initNgTablePayment();
            }).catch((error) => {
                console.log(error);
            this.statePayment.loading = false;
            this.statePayment.loaded = true;
            this.statePayment.error = true;
        });
    }

    blurPayment() {
        this.paymentSelected = null;
        this.watchingPayment = false;
        this.exportCorrectExcel = false;
        this.exportCorrectPdf = false;
    }

    initNgTablePayment() {

        this.ngTableColsPayment = [
            {
                field: "Tipo_Docto_cruce",
                title: "Tipo Docto Cruce",
                sortable: "Tipo_Docto_cruce",
                filter: {"Tipo_Docto_cruce": "text"},
                show: true
            },
            {
                field: "Nro_docto_cruce",
                title: "Número Docto Cruce",
                sortable: "Nro_docto_cruce",
                filter: {"Nro_docto_cruce": "number"},
                show: true
            },
            {
                field: "Valor_aplicado",
                title: "Valor Aplicado",
                sortable: "Valor_aplicado",
                filter: {"Valor_aplicado": "number"},
                show: true
            },
            {
                field: "Pronto_pago_aplicado",
                title: "Valor Pronto Pago Aplicado",
                sortable: "Pronto_pago_aplicado",
                filter: {"Pronto_pago_aplicado": "number"},
                show: true
            },
            {
                field: "Saldo_Docto",
                title: "Saldo del Documento",
                sortable: "Saldo_Docto",
                filter: {"Saldo_Docto": "number"},
                show: true
            }
        ];

        let initialParams = {
            count: 20
        };

        let initialSettings = {
            counts: [5, 10, 20],
            paginationMaxBlocks: 8,
            paginationMinBlocks: 2,
            dataset: this.paymentSelected
        };

        this.ngTableConfigPayment = new this.NgTableParams(initialParams, initialSettings);
    }

    initNgTable() {

        this.ngTableCols = [
            {
                field: "Fecha_Recaudo",
                title: "Fecha de pago",
                sortable: "Fecha_Recaudo",
                filter: {"Fecha_Recaudo": "text"},
                show: true
            },
            {
                field: "id_tipo_docto",
                title: "Tipo de doc",
                sortable: "id_tipo_docto",
                filter: {"id_tipo_docto": "text"},
                show: true
            },
            {
                field: "Nro_docto",
                title: "Pago",
                sortable: "Nro_docto",
                filter: {"Nro_docto": "number"},
                show: true
            },
            {
                field: "sucursal_id",
                title: "Centro de operación",
                sortable: "sucursal_id",
                filter: {"sucursal_id": "text"},
                show: true
            },
            {
                field: "Valor_recaudo",
                title: 'Valor Pagado',
                sortable: "Valor_recaudo",
                filter: {"Valor_recaudo": "number"},
                show: true
            },
            {
                field: "estado_documento",
                title: "Estado",
                sortable: "estado_documento",
                filter: {"estado_documento": "text"},
                show: true
            },
            {
                field: "Medio_pago",
                title: "Metodo de Pago",
                sortable: "Medio_pago",
                filter: {"Medio_pago": "text"},
                show: true
            },
            {
                field: "actions",
                title: "Detalle",
                show: true
            },
        ];

        let initialParams = {
            count: 20
        };

        let initialSettings = {
            counts: [5, 10, 20],
            paginationMaxBlocks: 8,
            paginationMinBlocks: 2,
            dataset: this.payments
        };

        this.ngTableConfig = new this.NgTableParams(initialParams, initialSettings);
    }

    exportExcel() {
        this.exportCorrectExcel = false;
        this.exportCorrectPdf = false;
        this.exportingData = true;
        //console.log(this.payments);
        let nameClient = this.shCtrl.globals.currentClient.third.name;

        let initDate = this.fechaDesde;
        let endDate = this.fechaHasta;
        let aplyDateFilter = this.showDateFilter;
        
        this.reportPaymentsService.getExportExcel(this.payments, nameClient, initDate, endDate, aplyDateFilter)
            .then((datos) => {
                console.log(datos.data.url_excel);
                open(datos.data.url_excel, '_blank');
                this.exportingData = false;
                this.exportCorrectExcel = true;

            }).catch((error) => {
                console.log(error);
                this.exportingData = false;
                this.exportCorrectExcel = false;

        });
    }

    exportPDF() {
        this.exportCorrectExcel = false;
        this.exportCorrectPdf = false;
        this.exportingDataPdf = true;
        let nameClient = this.shCtrl.globals.currentClient.third.name;
        let date = this.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');

        let initDate = this.fechaDesde;
        let endDate = this.fechaHasta;
        let aplyDateFilter = this.showDateFilter;
        
        this.reportPaymentsService.getExportPdf(this.payments, nameClient,  initDate, endDate, aplyDateFilter)
            .then((responsepdf) => {
                
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(responsepdf);
                link.download = `${nameClient}-historico-pagos-${date}.pdf`;
                link.target = '_blank';
                link.click();
                
                this.exportingDataPdf = false;
                this.exportCorrectPdf = true;

            }).catch((error) => {
                console.log(error);
                this.exportingDataPdf = false;
                this.exportCorrectPdf = false;

        });
    }

    exportPaymentExcel() {
        this.exportCorrectExcel = false;
        this.exportCorrectPdf = false;
        this.exportingData = true;
        //console.log(this.payments);
        let nameClient = this.shCtrl.globals.currentClient.third.name;
        
        this.reportPaymentsService.getExportDetailExcel( this.paymentSelectedBase , this.paymentSelected, nameClient)
            .then((datos) => {
                console.log(datos.data.url_excel);
                open(datos.data.url_excel, '_blank');
                this.exportingData = false;
                this.exportCorrectExcel = true;

            }).catch((error) => {
                console.log(error);
                this.exportingData = false;
                this.exportCorrectExcel = false;

        });
    }

    exportPaymentPDF() {
        this.exportCorrectExcel = false;
        this.exportCorrectPdf = false;
        this.exportingDataPdf = true;
        //console.log(this.payments);
        let nameClient = this.shCtrl.globals.currentClient.third.name;
        
        
        this.reportPaymentsService.getExportDetailPdf( this.paymentSelectedBase , this.paymentSelected, nameClient)
            .then((responsepdf) => {
                
                var date = this.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss')
                var nameFile = nameClient + '-detalle_pago_' + this.paymentSelectedBase.id_tipo_docto + this.paymentSelectedBase.Nro_docto+ '-' + date + '.pdf';
                
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(responsepdf);
                link.download = nameFile;
                link.target = '_blank';
                link.click();
                
                this.exportingDataPdf = false;
                this.exportCorrectPdf = true;

            }).catch((error) => {
                console.log(error);
                this.exportingDataPdf = false;
                this.exportCorrectPdf = false;

        });
    }


    showSort(value) {
        this.sort = value;
    }

    getFormattedDate(date,type='y-m-d') {
        let dateFormat = null;
        
        if(date != null && date != ''){
            if(date.getFullYear){
                let year = date.getFullYear();
          
                let month = (1 + date.getMonth()).toString();
                month = month.length > 1 ? month : '0' + month;
          
                let day = date.getDate().toString();
                day = day.length > 1 ? day : '0' + day;
                
                if(type == 'd/m/y'){
                    dateFormat = day + '-' + month + '/' + year;
                }else{
                    dateFormat = year + '-' + month + '-' + day;
                }
            } else{
                dateFormat = date;
            }
        }

        return dateFormat;
    }

    activeSortPayments(){
        console.log(this.payments);
        var sortType = this.sortType;

        this.payments.sort(function (a, b) {

            if(sortType == 'Nro_docto'){
                if (a.Nro_docto > b.Nro_docto) {
                    return 1;
                }
                if (a.Nro_docto < b.Nro_docto) {
                    return -1;
                }
                // a must be equal to b
                return 0;
            }

            if(sortType == 'Fecha_Recaudo'){
                if (a.Fecha_Recaudo.getTime() > b.Fecha_Recaudo.getTime()) {
                    return 1;
                }
                if (a.Fecha_Recaudo.getTime() < b.Fecha_Recaudo.getTime()) {
                    return -1;
                }
                // a must be equal to b
                return 0;
            }

            if(sortType == 'Valor_recaudo'){
                if (a.Valor_recaudo > b.Valor_recaudo) {
                    return 1;
                }
                if (a.Valor_recaudo < b.Valor_recaudo) {
                    return -1;
                }
                // a must be equal to b
                return 0;
            }

          });

        console.log(this.payments);

        if(this.sortOrientation == 'DESC'){
            this.payments.reverse(); 
            console.log(this.payments);
        }
    }
}

ReportPaymentHistoryController.$inject = inject;

export default ReportPaymentHistoryController;




/** WEBPACK FOOTER **
 ** ./www/components/reports/payment-history/payment-history.controller.js
 **/